import moment from 'moment';
import { dateToString } from '@/utils/helpers';

const DATE_DISPLAY_FORMAT = 'MM/DD/YYYY hh:mm A';
const TITLE_DATE_FORMAT = 'ddd MMM Do, YYYY';
const EMPTY_DISPLAY = '-';

const hasValue = value => value !== null && typeof value !== 'undefined' && value !== '';
const hasNumber = value => hasValue(value) && !Number.isNaN(Number(value));
const formatCurrency = (value) => {
  if (!hasNumber(value)) return EMPTY_DISPLAY;

  const amount = Number(value);
  return `$${amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export default {
  props: {
    request: {
      type: Object,
      required: true,
    },
  },
  computed: {
    requestDateValue() {
      if (!this.request) return null;

      return this.request.dateCreated || this.request.date || null;
    },
    paymentMethod() {
      return this.request && this.request.paymentMethod ? this.request.paymentMethod : EMPTY_DISPLAY;
    },
    requestTypeLabel() {
      if (this.request && this.request.paymentMethod) {
        return `${this.request.paymentMethod} Deposit`;
      }

      return 'Pending Deposit';
    },
    requestTitle() {
      if (!this.requestDateValue || !moment(this.requestDateValue).isValid()) {
        return this.requestTypeLabel;
      }

      return `${this.requestTypeLabel} on ${moment(this.requestDateValue).format(TITLE_DATE_FORMAT)}`;
    },
    formattedAmount() {
      return formatCurrency(this.request && this.request.amount);
    },
    formattedAmountReceived() {
      return formatCurrency(this.request && this.request.amountReceived);
    },
    formattedDate() {
      if (!this.requestDateValue || !moment(this.requestDateValue).isValid()) return EMPTY_DISPLAY;

      return dateToString(this.requestDateValue, DATE_DISPLAY_FORMAT);
    },
    showAmountReceived() {
      if (!this.request || !hasNumber(this.request.amountReceived)) return false;

      const amountReceived = Number(this.request.amountReceived);
      if (amountReceived <= 0) return false;

      if (!hasNumber(this.request.amount)) return true;

      return amountReceived !== Number(this.request.amount);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/pending-requests/pending-request-deposit/pending-request-deposit.js